import React from 'react'

const DetalheBagagem = ({ bagagem }) => {
  if (!bagagem?.exibirDetalhe) {
    return null
  }

  return (
    <div className="vx-row-detail">
      <div className="vx-row-detail-title">
        <span className="material-icons">info</span>
        Detalhes da Bagagem
      </div>
      <div className="vx-row-detail-grid">
        <div className="vx-row-detail-item">
          <div className="vx-row-detail-item-label">Tipo de cálculo</div>
          <div className="vx-row-detail-item-value">{bagagem.descTipoCalculoBagagem || '-'}</div>
        </div>
        <div className="vx-row-detail-item">
          <div className="vx-row-detail-item-label">Passageiro</div>
          <div className="vx-row-detail-item-value">{bagagem.nomePassageiro || '-'}</div>
        </div>
      </div>

      <div className="vx-row-detail-pay">
        <div className="vx-row-detail-pay-title">Formas de Pagamento</div>
        {bagagem.formasPagamento && bagagem.formasPagamento.length > 0 ? (
          bagagem.formasPagamento.map((fp, index) => (
            <div className="vx-row-detail-pay-item" key={index}>
              <span><strong>{fp.tipo}</strong></span>
              <span>{fp.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
              <span style={{color: '#888'}}>Parcelas: {fp.quantidadeParcelas}</span>
            </div>
          ))
        ) : (
          <p style={{margin: 0, color: '#bbb', fontSize: 13}}>Nenhuma forma de pagamento informada</p>
        )}
      </div>
    </div>
  )
}

export default DetalheBagagem
